import { FC } from 'react';
import { useAppSelector } from '../redux/hooks';
import { selectUser } from '../redux/reducers/userSlice';
import { Roles } from '../models/User';
import { StudentAssignments } from '../components/Assignments/StudentAssignments';
import { TeacherAssignments } from '../components/Assignments/TeacherAssignments';

export const Assignments: FC = () => {
  const user = useAppSelector(selectUser);

  return <>{user?.roles.some(role => role.name === Roles.STUDENT) ? <StudentAssignments /> : <TeacherAssignments />}</>;
};
